import React from "react";
import { SNS_ELIGIBILITY_FILTER } from "~/store/mystore/subscribeAndSave.redux";
import TableFilter from "~/components/panel/panelActions/tableFilter";

const SubscribeAndSaveEligibilityFilterSelect = ({
  setSelected,
  selected,
  width = "180px",
}: {
  setSelected: (value: SNS_ELIGIBILITY_FILTER) => void;
  selected: SNS_ELIGIBILITY_FILTER;
  width?: string;
}) => {
  const ELIGIBILITY_OPTIONS = Object.keys(SNS_ELIGIBILITY_FILTER).map((o) => ({
    label: o,
    value: o,
  }));
  const switchEligibility = (value: string) => {
    const option = ELIGIBILITY_OPTIONS.find(
      (eligibility) => eligibility.value === value
    );
    if (option) {
      setSelected(value as SNS_ELIGIBILITY_FILTER);
    }
  };

  return (
    <TableFilter
      {...{
        width,
        options: ELIGIBILITY_OPTIONS,
        currentValue: selected,
        handleChange: switchEligibility,
      }}
    />
  );
};

export default SubscribeAndSaveEligibilityFilterSelect;
